"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servicesCodeIcon = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var servicesCodeIcon = {
  datasheet: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tooltip",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "material-icons small",
      children: "\uF8EE"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "tooltiptext",
      children: "Ficha T\xE9cnica"
    })]
  }, "datasheet"),
  description: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tooltip",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "material-icons small",
      children: "\uE873"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "tooltiptext",
      children: "Descripci\xF3n"
    })]
  }, "description"),
  image: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tooltip",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "material-icons small",
      children: "\uE3F4"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "tooltiptext",
      children: "Imagen"
    })]
  }, "image"),
  translate: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tooltip",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "material-icons small",
      children: "\uE8E2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "tooltiptext",
      children: "Traducci\xF3n"
    })]
  }, "translate"),
  build: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tooltip",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "material-icons small",
      children: "\uE1BD"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "tooltiptext",
      children: "Construcci\xF3n"
    })]
  }, "build")
};
exports.servicesCodeIcon = servicesCodeIcon;